var exports = {
  "Q": "x04b3a21e--58af53--content",
};

module.exports = exports;
